/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import {IClubForm} from 'packages/common-types/base-types';
import {useFormContext} from 'react-hook-form';
import FormAddress from 'packages/auth/register/FormAddress';
import FormNameClub from './FormNameClub';

type Props = {
  onSubmit: (credentials: IClubForm) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  submitting?: boolean;
};

const ClubForm = ({onSubmit}: Props) => {
  const {handleSubmit} = useFormContext<IClubForm>();
  return (
    <>
      <form
        id="create-club-form"
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="off"
      >
        <FormNameClub />
        <FormAddress />
      </form>
    </>
  );
};

export default ClubForm;
